import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import useModal from 'shared/hooks/useModal';
import {withState} from 'shared/core';
import {Button, Panel} from 'shared/components';
import {TimeTrackingDimension} from 'main/stores/time_tracking';
import DimensionPanel from './DimensionPanel';
import EditDimensionModal from './EditDimensionModal';
import RemoveDimensionModal from './RemoveDimensionModal';
import ReorderDimensionsModal from './ReorderDimensionsModal';
import {DimensionDirectoryState} from '../state';
import _ from 'lodash';

const Dimensions = observer(({uiState}) => {
  const {sortedDimensions} = uiState;

  if (_.isEmpty(sortedDimensions)) {
    return (
      <Panel>
        <div className='center jumbo rounded h5 py2 px1 Table-emptyState' style={{marginBottom: 0}}>
          <FormattedMessage id='time_tracking.dimensions.NO_DIMENSIONS_MESSAGE'/>
        </div>
      </Panel>
    );
  }

  return (
    <Panel.Stack loose>
      {sortedDimensions.map(dimension =>
        <DimensionPanel
          dimension={dimension}
          onEditDimension={() => uiState.openEditDimensionModal(dimension)}
          key={dimension.id}
        />
      )}
    </Panel.Stack>
  );
});

const DimensionDirectory = observer(({uiState}) => {
  const editDimensionModalOpen = useModal(uiState, 'EditDimensionModal', 'editingDimension', TimeTrackingDimension, 'errors');
  const removeDimensionModalOpen = useModal(uiState, 'RemoveDimensionModal');
  const reorderDimensionsModalOpen = useModal(uiState, 'ReorderDimensionsModal');

  return (
    <div>
      <div className='mb2 right-align'>
        <Button size='sm' trait='default' onClick={() => uiState.openReorderDimensionsModal()}>
          <FormattedMessage id='time_tracking.dimensions.Reorder Dimensions'/>
        </Button>
        <Button className='ml2' size='sm' onClick={() => uiState.openEditDimensionModal()}>
          <FormattedMessage id='time_tracking.dimensions.+ Add Dimension'/>
        </Button>
      </div>
      <Dimensions uiState={uiState}/>
      <EditDimensionModal uiState={uiState} modalOpen={editDimensionModalOpen}/>
      <RemoveDimensionModal uiState={uiState} modalOpen={removeDimensionModalOpen}/>
      <ReorderDimensionsModal uiState={uiState} modalOpen={reorderDimensionsModalOpen}/>
    </div>
  );
});

export default withState(DimensionDirectory, DimensionDirectoryState);
